import React, { useState, useEffect } from 'react';
import { Container, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../Card/Card';
import Tour from 'reactour';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { startUpdateNovicePopupAmount, setTourStep } from '../../actions/webmaster';
import Icon from '../Icon/Icon';

const FirstSteps = () => {
  const dispatch = useDispatch();
  const popupAmount = useSelector(state => state.webmaster.profile.justRegistered.popupAmount);
  const {
    justRegistered: { is, hasOffer, hasStream, hasLead },
  } = useSelector(state => state.webmaster.profile);

  // const [isTourOpen, toggleTour] = useState(true);
  const [isTourOpen, toggleTour] = useState(false);
  const [currentStep, getCurrentStep] = useState(0);
  const [isBannerHidden, setIsBannerHidden] = useState(false);

  useEffect(() => {
    popupAmount < 2 && dispatch(startUpdateNovicePopupAmount());
  }, []);

  useEffect(() => {
    popupAmount === 1 && toggleTour(true);
  }, [popupAmount]);

  useEffect(() => {
    const bannerPreference = localStorage.getItem('hideFirstStepsBanner');
    bannerPreference && setIsBannerHidden(true);
  }, []);

  const renderContent = (goTo, currentStep) => (
    <div>
      <FormattedHTMLMessage tagName="div" id={`tour.steps.${currentStep}`} />
      {renderControls(currentStep, goTo)}
    </div>
  );

  const skipTour = () => {
    dispatch(startUpdateNovicePopupAmount());
    toggleTour(false);
  };
  const renderControls = (currentStep, goTo) => (
    <div className="mt-2">
      {currentStep !== 0 && (
        <Button size="sm" color="primary" onClick={goTo.bind(null, currentStep)}>
          <FormattedMessage id="tour.buttons.next" defaultMessage="Next" />
        </Button>
      )}
      <Button size="sm" color={currentStep === 0 && 'primary'} onClick={skipTour.bind(null)}>
        <FormattedMessage
          id={`tour.buttons.close${currentStep === 0 ? '.final' : ''}`}
          defaultMessage="Got it!"
        />
      </Button>
    </div>
  );

  const hideBanner = () => {
    setIsBannerHidden(true);
    localStorage.setItem('hideFirstStepsBanner', true);
  };

  const steps = [
    {
      selector: '[data-tut="tour-help"]',
      content: ({ goTo, inDOM }) => {
        dispatch(setTourStep(1, true));
        return renderContent(goTo, currentStep + 1);
      },
      position: 'bottom',
    },
    // {
    //   selector: '[data-tut="tour-manager"]',
    //   content: ({ goTo, inDOM }) => {
    //     dispatch(setTourStep(1, false));
    //     return renderContent(goTo, currentStep + 1);
    //   },
    //   position: 'bottom',
    // },
    {
      selector: '[data-tut="tour-themes"]',
      content: ({ goTo, inDOM }) => renderContent(goTo, currentStep + 1),
      position: 'bottom',
    },
    // {
    //   selector: '[data-tut="tour-profile"]',
    //   content: ({ goTo, inDOM }) => renderContent(goTo, 0),
    //   position: 'bottom',
    // },
    {
      selector: '[data-tut="tour-coins"]',
      content: ({ goTo, inDOM }) => renderContent(goTo, 0),
      position: 'bottom',
    },
  ];

  return is && !isBannerHidden && (!hasStream || !hasOffer || !hasLead) ? (
    <Container>
      <Tour
        className={
          currentStep === 1
            ? 'tour shevron-left'
            : currentStep === 2
            ? 'tour shevron-top-left-coins'
            : // : currentStep === 1
              // ? 'tour extended-width'
              'tour shevron-top-left'
        }
        closeWithMask={false}
        rounded={4}
        showNumber={false}
        steps={steps}
        disableInteraction={true}
        showCloseButton={false}
        getCurrentStep={curr => getCurrentStep(curr)}
        isOpen={isTourOpen}
        showButtons={false}
        showNavigation={false}
        onRequestClose={skipTour.bind(null)}
      />
      <Card className="step-wrapper" id="step-wrapper">
        <Card.Body className={`${hasOffer ? 'step active' : 'step step-first'}`}>
          <div className="step-number">
            <div className="step-number-inner">1</div>
          </div>
          <div className="step-text">
            <h3 className="step-text-title">
              <FormattedMessage id="tour.first-steps.1.title" defaultMessage="Select offers" />
            </h3>
            <p className="step-text-subtitle">
              <FormattedMessage
                id="tour.first-steps.1.subtitle"
                defaultMessage="Choose the offers you are interested in from the current promotional offers"
              />
            </p>
          </div>
        </Card.Body>

        <Card.Body className={`step ${hasStream && 'active'}`}>
          <div className="step-number">
            <div className="step-number-inner">2</div>
          </div>
          <div className="step-text">
            <h3 className="step-text-title">
              {/* Создайте поток */}
              <FormattedMessage id="tour.first-steps.2.title" defaultMessage="Create flow" />
            </h3>
            <p className="step-text-subtitle">
              <FormattedMessage
                id="tour.first-steps.2.subtitle"
                defaultMessage="Generate link codes for placement on websites"
              />
            </p>
          </div>
        </Card.Body>

        <Card.Body className="step">
          <div className="step-number">
            <div className="step-number-inner">3</div>
          </div>
          <div className="step-text">
            <h3 className="step-text-title">
              <FormattedMessage id="tour.first-steps.3.title" defaultMessage="Get profit!" />
            </h3>
          </div>
        </Card.Body>
        <Icon type="cross" className="close" tabIndex={0} onClick={hideBanner} />
      </Card>
    </Container>
  ) : null;
};

export default FirstSteps;
